import * as React from 'react';

import logoSrc from './logo.svg';

export const CreSpaceLogo: React.VFC = () => {
  return <img src={logoSrc} alt="CRE.Space logo" />;
};

CreSpaceLogo.displayName = 'CreSpaceLogo';
